import {
  LegacyProductCode,
  ProductBehavior,
} from '@up2stay/up2promo-api-client';

/**
 * Derives redirect behaviour type from product kind. Users only choose product kind; type is never shown.
 */
export function productTypeToBehaviorType(
  productType?: LegacyProductCode | string | null,
): ProductBehavior {
  switch (productType) {
    case LegacyProductCode.BC:
      return ProductBehavior.PROFILE;
    case LegacyProductCode.GO:
      return ProductBehavior.GOOGLE_REVIEW;
    case LegacyProductCode.IG:
      return ProductBehavior.INSTAGRAM;
    case LegacyProductCode.ME:
      return ProductBehavior.MENU;
    case LegacyProductCode.FB:
      return ProductBehavior.FACEBOOK;
    case LegacyProductCode.TT:
      return ProductBehavior.TIKTOK;
    case LegacyProductCode.CU:
    default:
      return ProductBehavior.URL;
  }
}

/**
 * Derives product kind from the target kind. Used when product type is not from scan (e.g. manual setup).
 */
export function behaviorTypeToProductType(
  type?: ProductBehavior | string | null,
): LegacyProductCode {
  switch (type) {
    case ProductBehavior.PROFILE:
      return LegacyProductCode.BC;
    case ProductBehavior.GOOGLE_REVIEW:
      return LegacyProductCode.GO;
    case ProductBehavior.INSTAGRAM:
      return LegacyProductCode.IG;
    case ProductBehavior.MENU:
      return LegacyProductCode.ME;
    case ProductBehavior.FACEBOOK:
      return LegacyProductCode.FB;
    case ProductBehavior.TIKTOK:
      return LegacyProductCode.TT;
    case ProductBehavior.URL:
    default:
      return LegacyProductCode.CU;
  }
}
